export const MAX_HEIGHT_ON_DESKTOP = 1280;
export const MIN_HEIGHT_ON_DESKTOP = 720;
